export default __webpack_public_path__ + "static/media/icon-married.40d8806b.svg";